<template>
  <div class="ma-4">
    <ClientNav />

    <MedicationInventoryDialog 
      ref="inventory"
      :item="selectedItem"
      
    />
    <v-row dense>
      <v-col cols="12" lg="3" xl="2">
        <ClientSide />
      </v-col>

      <v-col cols="12" lg="9" xl="10" class=" hideOnPrint">
        <v-data-table
          :headers="headers"
          :items="getClientInventoryLogs"
          class="elevation-1"
        >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                clearable
                flat
                solo-inverted
                hide-details
                prepend-inner-icon="search"
                label="search"
                dense
                height="20"
              >
                <template v-slot:append>
                  <v-btn color="primary" class="mr-n3">search</v-btn>
                </template>
              </v-text-field>
              <v-spacer></v-spacer>
                <report-list-actions
                :reportOptions="reportOptions"
                :downloadFilename="reportListFilename"
                ></report-list-actions>
            </v-toolbar>
          </template>

          <template v-slot:item.totalMedication="{ item }">
            <v-chip color="green" dark>
              {{ item.totalMedication }}
            </v-chip>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-icon
              small
              class="mr-2 hidden-sm-and-down"
              @click="viewItem(item)"
            >
              mdi-eye
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

import ClientNav from "../../components/ClientNav";
import ClientSide from "../../components/ClientSide";
import MedicationInventoryDialog from "../../components/medicationInventory/MedicationInventoryDialog";
import ReportListActions  from '@/components/Report/ReportListActions.vue';

export default {
  components: {
    ClientNav,
    ClientSide,
    MedicationInventoryDialog,
    ReportListActions
  },
  data() {
    return {
      headers: [
        {
          text: "Medication",
          align: "start",
          sortable: false,
          value: "medication",
        },
        { text: "Total Medications", value: "totalMedication" },
        { text: "Verified By", value: "verifiedBy" },
        { text: "Actions", value: "actions" },
      ],
      clientId: this.$route.params.clientID || localStorage.getItem("clientId"),
      search: "",
      selectedItem: {},
      showSignaturePad: false,
      staffDigitalSignature: "",
      reportListFilename: 'CS Medication',
    };
  },
  created() {
    this.getClientLogs(this.clientId);
  },
  computed: {
    ...mapGetters({
      getClientInventoryLogs: "medicationInventory/getClientInventoryLogs",
    }),
    csvDialog: {
      get() {
        return this.$store.state.shifts.csvDialog;
      },
      set(val) {
        this.$store.commit("shifts/SET_CSV_DIALOG", val);
      },
    },
    reportHeaderText() {
        return 'CS Medication';
    },
    reportData() {
        return this.getClientInventoryLogs
    },
    reportTableHeader() {
        return this.headers.slice(0, this.headers.length-1);
    },
    reportOptions() {
        return { 
            query: {
              clientID: this.clientId,
              clientName: this.$store.state.clients.client?.Name
            },
            endpoints: `medicationInventory/print-client-report`,
            dynamic: true
        }
    }
  },
  methods: {
    ...mapMutations({
      setDialog: "medicationInventory/SET_DIALOG",
    }),
    ...mapActions({
      getClientLogs: "medicationInventory/getClientLogs",
    }),

    viewItem(item) {
      this.selectedItem = item
      this.setDialog(true)
      this.$refs.inventory.onViewItem(item)
    }
  },
};
</script>
<style>

@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }

}
@media print {

  .hideOnPrint {
    display: none;
    border: none;
  }

  nav.v-navigation-drawer, header.v-toolbar, button.v-btn, div.v-card {
    display: none;
    border: none;

  }

  @page { margin: 0; }
  body { margin: 1.6cm; }
}
</style>
